// Avisos en línea de la liga a partir de los Message de PrimeNG (responseMessage):
// misma alerta .lx-alerta, ícono y rol en todas las pantallas. Así los mensajes del
// API se ven dentro de la pantalla y no en un p-messages que desaparece.
import {Message} from "primeng/api";
import {
  faCheck,
  faCircleExclamation,
  faCircleInfo,
  faTriangleExclamation,
  IconDefinition
} from "@fortawesome/free-solid-svg-icons";

export interface ITonoMensajeLx {
  // Clase de la alerta: <div class="lx-alerta" [ngClass]="tono.clase">.
  clase: string
  icono: IconDefinition
  // «alert» interrumpe al lector de pantalla (errores); «status» espera su turno.
  rol: 'alert' | 'status'
}

export const TONOS_MENSAJE_LX: Record<string, ITonoMensajeLx> = {
  success: {clase: 'lx-alerta--exito', icono: faCheck, rol: 'status'},
  info: {clase: 'lx-alerta--info', icono: faCircleInfo, rol: 'status'},
  warn: {clase: 'lx-alerta--aviso', icono: faTriangleExclamation, rol: 'status'},
  error: {clase: 'lx-alerta--error', icono: faCircleExclamation, rol: 'alert'}
}

export function tonoMensajeLx(mensaje: Message | null | undefined): ITonoMensajeLx {
  return TONOS_MENSAJE_LX[mensaje?.severity ?? 'info'] ?? TONOS_MENSAJE_LX['info']
}

// trackBy: un mensaje con el mismo texto no se vuelve a pintar (ni a anunciar),
// p. ej. el aviso que se reescribe cada segundo durante la espera del microdepósito.
export function porMensajeLx(_indice: number, mensaje: Message): string {
  return `${mensaje.severity ?? ''}|${mensaje.summary ?? ''}`
}
